import { useTranslation } from "react-i18next"
import { TimezoneId } from "../constants/timezones";
import { Timezone, UseTimezonesValue } from "../types/timezones";
import { GENETIC_COUNSELING_TRANSLATION } from "../constants";

const useTimezones = (): UseTimezonesValue => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);
  const timezones: Timezone[] = Object.values(TimezoneId).map(tz => ({
    id: tz,
    label: t(`timezones.${tz}`)
  }))
  return {
    timezones
  }
}

export default useTimezones;
